import { Card, CardContent, CardHeader } from "@mui/material";
import { User } from "../../../app/backendTypes";
import EmployeeFields from "./EmployeeFields";
import CanLoginDisplay from "./CanLoginDisplay";

function DisplayUser(props: { user: User }) {
  const { user } = props;

  return (
    <Card sx={{ width: "100%", maxWidth: "sm" }}>
      <CardHeader
        title={user.employee.name}
        subheader={user.employee.id}
        action={<CanLoginDisplay user={user} />}
      />
      <CardContent>
        <EmployeeFields employee={user.employee} />
      </CardContent>
    </Card>
  );
}

export default DisplayUser;
